import axios from 'axios';
import { routePrefix } from '../app/App';

export type Translations = Record<string, string>;

export async function getTranslations(query: string): Promise<Translations> {
  const url = `${routePrefix()}translationText${query}`;
  const { data } = await axios.get<Translations>(url);
  return data;
}

